import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import BankAccount from "./BankAccount";

/**
 * DAO для работы с расчетными счетами
 */
class BankAccountsDAO {

  static async add(companyId: number, bankAccount: BankAccount): Promise<RpcResponse> {
    return await RpcService.makeRequest('bankAccounts.add', {
      companyId,
      bankAccount
    });
  }

  static async delete(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('bankAccounts.delete', { id });
  }

  static async setMain(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('bankAccounts.setMain', { id });
  }

  static async get(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('bankAccounts.get', { id });
  }

  static async getList(companyId: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('bankAccounts.getList', { companyId });
  }
}

export default BankAccountsDAO;
